export default __webpack_public_path__ + "static/media/full_window.ae34457b.png";